var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpisodeIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.25 0 16.5 0 25 0 C25 5.61 25 11.22 25 17 C23.35 17 21.7 17 20 17 C20 17.66 20 18.32 20 19 C15.05 19 10.1 19 5 19 C5 18.34 5 17.68 5 17 C3.35 17 1.7 17 0 17 C0 11.39 0 5.78 0 0 Z M1 2 C1 6.29 1 10.58 1 15 C8.59 15 16.18 15 24 15 C24 10.71 24 6.42 24 2 C16.41 2 8.82 2 1 2 Z ",
    fill: "#9D9D9D",
    transform: "translate(0,3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 2.31 2 4.62 2 7 C1.34 7 0.68 7 0 7 C-0.38133299 5.0085944 -0.71325582 3.00720923 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#9D9D9D",
    transform: "translate(12,8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpisodeIco);
export default __webpack_public_path__ + "static/media/episode_ico.9e7db432ad920dd8da255bbc4bfa25b8.svg";
export { ForwardRef as ReactComponent };